import { ButtonProps, styled } from "@mui/material";
import ButtonBase from "./BaseButton";

interface GreenButtonProps extends ButtonProps {
  inheritHeight?: boolean;
  variantButton?: "filled" | "outline";
}

const GreenButton = (props: GreenButtonProps) => {
  const { inheritHeight = true, variantButton = "filled", ...rest } = props;
  return (
    <StyledAcceptButton
      inheritHeight={inheritHeight}
      variantButton={variantButton}
      variant={variantButton === "filled" ? "contained" : "outlined"}
      {...rest}
    />
  );
};

const StyledAcceptButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "inheritHeight" && prop !== "variantButton",
})<{ inheritHeight?: boolean; variantButton?: "filled" | "outline" }>(
  ({ theme, inheritHeight, variantButton }) => ({
    fontWeight: 500,
    height: inheritHeight ? "100%" : "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    padding: "8px 16px",
    textDecoration: "none",
    fontSize: 14,

    // Ensure no underline in any state
    "&, &:hover, &:focus, &:active, &:visited": {
      textDecoration: "none !important",
    },

    // Filled variant styles
    ...(variantButton === "filled" && {
      color: "#fff",
      backgroundColor: "var(--sub-color)",
      border: "none",
      "&:hover": {
        backgroundColor: "var(--green-800)",
        textDecoration: "none",
      },
      "&.Mui-disabled": {
        backgroundColor: "#D0D5DD",
        color: "#fff",
      },
    }),

    // Outline variant styles
    ...(variantButton === "outline" && {
      color: "var(--sub-color)",
      backgroundColor: "transparent",
      border: "1px solid var(--sub-color)",
      "& svg": {
        fill: "var(--sub-color)",
        color: "var(--sub-color)",
      },
      "&:hover": {
        backgroundColor: "rgba(34, 197, 94, 0.08)",
        borderColor: "var(--green-800)",
        textDecoration: "none",
      },
      "&.Mui-disabled": {
        borderColor: "#D0D5DD",
        color: "#D0D5DD",
        backgroundColor: "transparent",
        "& svg": {
          fill: "#D0D5DD",
          color: "#D0D5DD",
        },
      },
    }),

    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      padding: "8px 12px",
    },
  })
);

export default GreenButton;
